import { store, getContext, getElement } from "@wordpress/interactivity";

const NAMESPACE = "mgblocks/testimonialsv3";

const { state } = store(NAMESPACE, {
	state: {},
	actions: {
		goToSlide() {
			const context = getContext();
			context.currentIndex = context.index;
			// context.isOpen = !context.isOpen;
			console.log(context.currentIndex);
		},
	},
	callbacks: {
		isActiveSlide() {
			const context = getContext();
			return context.index === context.currentIndex;
		},
	},
});
